import { QueryCache, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      const errorNotification = query.meta?.errorNotification;
      if (errorNotification && errorNotification.title) {
        window.showNotification({
          titleMsg: errorNotification.title,
          bodyMsg: errorNotification.message,
          severity: 'error',
        });
      }
    },
  }),
});
